/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import dayjs from "dayjs"
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import ComboBox from "../../../components/ComboBox"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import TextInput from "../../../components/InputWrapper/TextInput"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"

import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import TenkenService from "../../../service/truck/tenken/tenkenService"
import {
  TTenkenSeibihiListGetReq,
  TTenkenSeibihiListGetRes,
} from "../../../service/truck/tenken/TTenken"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

// import TenkenSeibiModal from "../TenkenSeibiList/TenkenseibiModal"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { T支払先 } from "../../../components/ComboBox/SiharaiSakiComboBox"
import DateInput from "../../../components/InputWrapper/DateInput"
import { e支払先区分 } from "../../../constant/enum/master"
import BusyoService from "../../../service/master/busyo/busyoService"
import { FunctionContext } from "../../../components/Context"
import TenkenSeibiModal from "../TenkenSeibiList/TenkenseibiModal"
import SiharaisakiService from "../../../service/master/siharaisaki/siharaisakiService"
import {
  tenkenseibihiExcelFormat,
  tenkenseibihiPdfFormat,
} from "../../../ts/util/haisyaUtil"
import stringUtil from "../../../ts/util/stringUtil"
import dateUtil from "../../../ts/util/dateUtil"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import Decimal from "decimal.js"

// #region ComboBoxDummy

// DefaultCombo
export type T日付切替 = { name: string; value: any }

// defaultComboBox用
const boolList: T日付切替[] = [
  {
    name: "実施",
    value: 0,
  },
  {
    name: "予定",
    value: 1,
  },
]
// #endregion

/**
 * 点検整備費
 * @returns
 */
const TenkenSeibihiList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "TenkenSeibihiList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TTenkenSeibihiListGetRes>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        整備費用合計_税込: (d: TTenkenSeibihiListGetRes) => {
          return new Decimal(d?.点検整備費 ?? 0)
            .plus(d?.その他費用 ?? 0)
            .plus(d?.その他費用非課税 ?? 0)
            .plus(d?.消費税 ?? 0)
            .toNumber()
        },
      },

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  const beforeSearch = () => {
    // バリデーションチェック
    if (!isValidationCheckBeforeSearch()) return
    search()
  }

  /**
   * 検索時のチェック
   */
  const isValidationCheckBeforeSearch = () => {
    dispatch(clearAlert())
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []

    // 日付のFromTo相関チェック
    if (日付From != null && 日付To != null) {
      // 実施日がFromToともに設定済みの場合に判定
      if (日付To < 日付From) {
        messages.push(
          `実施日の開始～終了日は逆転しないように入力してください。`
        )
        hasError = true
      }
    }

    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSearched(hasError)
    }
    return !hasError
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TTenkenSeibihiListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TTenkenSeibihiListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }

    if (currentSearchCondition == null) return
    setPreSearchCondition({ ...currentSearchCondition })

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new TenkenService().getSeibihiList(
        currentSearchCondition
      )

      // 結果をセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
      flexGrid?.refresh()
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TTenkenSeibihiListGetReq = queryString.parse(location.search)
    set日付From(query.実施日From)
    set日付To(query.実施日To)
    set請求年月(query.請求年月)
    set車番(query.車番)
    setシリアルNo(query.車台番号)
    set車台番号(query.車台番号)
    set部所コード(query.部所コード)
    set整備業者コード(query.整備業者コード)
    set日付切替コード(query.日付切替コード)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TTenkenSeibihiListGetReq => {
    // 請求年月が無い場合のみ予定・実施日を検索項目に設定
    if (stringUtil.isNullOrWhiteSpace(請求年月)) {
      return {
        日付切替コード: 日付切替コード,

        // 日付切替コードで日付State変数を振り分ける
        実施日From: 日付切替コード === 0 ? 日付From ?? undefined : undefined,
        実施日To: 日付切替コード === 0 ? 日付To ?? undefined : undefined,
        予定日From: 日付切替コード === 1 ? 日付From ?? undefined : undefined,
        予定日To: 日付切替コード === 1 ? 日付To ?? undefined : undefined,

        請求年月: undefined,
        車番,
        シリアルNo,
        車台番号,
        部所コード: 部所コード ?? "",
        整備業者コード: 整備業者コード ?? "",
      }
    } else {
      return {
        日付切替コード: 日付切替コード,
        実施日From: undefined,
        実施日To: undefined,
        予定日From: undefined,
        予定日To: undefined,

        請求年月: dateUtil.format(請求年月!, "YYYY/MM/1"),
        車番,
        シリアルNo,
        車台番号,
        部所コード: 部所コード ?? "",
        整備業者コード: 整備業者コード ?? "",
      }
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TTenkenSeibihiListGetReq
  ) => {
    let disp予定日From: string = ""
    let disp予定日To: string = ""
    let disp実施日From: string = ""
    let disp実施日To: string = ""

    // 請求年月が無い場合のみ予定・実施日を表示
    if (stringUtil.isNullOrWhiteSpace(請求年月)) {
      if (searchCondition.予定日From) {
        disp予定日From = dayjs(searchCondition.予定日From).format("YYYY/MM")
      }
      if (searchCondition.予定日To) {
        disp予定日To = dayjs(searchCondition.予定日To).format("YYYY/MM")
      }
      if (searchCondition.実施日From) {
        disp実施日From = dayjs(searchCondition.実施日From).format("YYYY/MM")
      }
      if (searchCondition.実施日To) {
        disp実施日To = dayjs(searchCondition.実施日To).format("YYYY/MM")
      }
    }

    return {
      予定日From: wjCore.isNullOrWhiteSpace(disp予定日From ?? "")
        ? ""
        : disp予定日From,
      予定日To: wjCore.isNullOrWhiteSpace(disp予定日To ?? "")
        ? ""
        : disp予定日To,
      実施日From: wjCore.isNullOrWhiteSpace(disp実施日From ?? "")
        ? ""
        : disp実施日From,
      実施日To: wjCore.isNullOrWhiteSpace(disp実施日To ?? "")
        ? ""
        : disp実施日To,
      請求年月: dateUtil.format(請求年月, "YYYY/MM"),
      部所: 部所コード,
      車番,
      シリアルNo,
      車台番号,
      整備業者: 整備業者コード,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    set日付From(eigyobi)
    set日付To(eigyobi)
    set請求年月("")
    set車番("")
    setシリアルNo("")
    set車台番号("")

    set部所コード("")
    set整備業者コード("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  // modal
  const [isTenkenSeibi, setIsTenkenSeibi] = useState(false)

  // モーダル側との検索動作判定用
  const [preSearchCondition, setPreSearchCondition] =
    useState<TTenkenSeibihiListGetReq>({} as TTenkenSeibihiListGetReq)

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  // state
  const [日付From, set日付From] = useState<string | null>()
  const [日付To, set日付To] = useState<string | null>()
  const [請求年月, set請求年月] = useState<string | null>()
  const [車番, set車番] = useState<string>()
  const [シリアルNo, setシリアルNo] = useState<string>()
  const [車台番号, set車台番号] = useState<string>()

  // modal受け渡し用
  const [車輌点検整備ID, set車輌点検整備ID] = useState<number>()
  const [車輌ID, set車輌ID] = useState<number>()

  //#endregion

  //#region comboboxState
  // 部所
  const [部所コード, set部所コード] = useState<string | null>()
  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)

  // 整備業者
  const [整備業者コード, set整備業者コード] = useState<string | null>()
  const [, set整備業者] = useState<T支払先 | null>()
  const [整備業者ItemSource, set整備業者ItemSource] = useState<T支払先[]>()
  const [整備業者ComboBox, set整備業者ComboBox] = useState<TWijmoComboBox<
    T支払先["支払先コード"],
    T支払先
  > | null>(null)
  const [整備業者IsLoadEnded, set整備業者IsLoadEnded] = useState<boolean>(false)

  const [comboDataInitialized, setComboDataInitialized] =
    useState<boolean>(false)
  // 日付切替
  const [日付切替コード, set日付切替コード] = useState<number>()
  const [, set日付切替] = useState<T日付切替 | null>()
  const [日付切替ComboBox, set日付切替ComboBox] = useState<TWijmoComboBox<
    number,
    T日付切替
  > | null>(null)
  const [日付切替IsLoadEnded, set日付切替IsLoadEnded] = useState<boolean>(false)
  const [日付切替ItemSource, set日付切替ItemSource] = useState<T日付切替[]>()

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)
  const [Form外エラーメッセージList] = useState<string[]>([])
  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `点検整備費 一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  useEffect(() => {
    if (!部所IsLoadEnded || !整備業者IsLoadEnded || !日付切替IsLoadEnded) return
    setComboDataInitialized(true)
  }, [部所IsLoadEnded, 整備業者IsLoadEnded, 日付切替IsLoadEnded])

  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new SiharaisakiService().getList({}),
    ]).then(([部所ListRes, 支払先ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      set整備業者ItemSource(支払先ListRes.data)
      set日付切替ItemSource(boolList)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        set日付From(eigyobi)
        set日付To(eigyobi)
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, comboDataInitialized])

  // error監視
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      dispatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">点検整備費 一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-70rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <Form>
                  <Container fluid className="contents-search-main">
                    {/* 固定項目 */}
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div>
                              <ComboBox.Busyo
                                autoFocus
                                placeholder="部所"
                                isAllSelect={true}
                                itemsSource={部所ItemSource}
                                isLoadEnded={部所IsLoadEnded}
                                setIsLoadEnded={set部所IsLoadEnded}
                                setSelectedValue={set部所コード}
                                selectedValue={部所コード}
                                setSelectedItem={set部所}
                                ComboBox={部所ComboBox}
                                setComboBox={set部所ComboBox}></ComboBox.Busyo>
                            </div>
                            <div className="w-9rem">
                              <ComboBox.Default
                                placeholder="検索日付"
                                itemsSource={日付切替ItemSource}
                                isLoadEnded={日付切替IsLoadEnded}
                                setIsLoadEnded={set日付切替IsLoadEnded}
                                setSelectedValue={set日付切替コード}
                                selectedValue={日付切替コード}
                                setSelectedItem={set日付切替}
                                ComboBox={日付切替ComboBox}
                                setComboBox={
                                  set日付切替ComboBox
                                }></ComboBox.Default>
                            </div>
                            <div className="w-16rem">
                              <DateInput
                                id="日付From"
                                placeholder="From"
                                has1DayButton={true}
                                value={日付From}
                                setValue={(v) => {
                                  set日付From(v)
                                }}></DateInput>
                            </div>
                            <div className="w-16rem">
                              <DateInput
                                id="日付To"
                                placeholder="To"
                                value={日付To}
                                has1DayButton={true}
                                setValue={(v) => {
                                  set日付To(v)
                                }}></DateInput>
                            </div>
                            <div className="w-10rem">
                              <MonthInput
                                id="請求年月"
                                value={請求年月}
                                setValue={(v) => set請求年月(v!)}
                                placeholder="請求年月"
                              />
                            </div>
                          </div>
                          <div className="search-condition-row">
                            <TextInput
                              style={{ width: "5rem" }}
                              id="車番"
                              name="車番"
                              value={車番}
                              setValue={set車番}
                              maxLength={4}
                              placeholder="車番"
                            />
                            <TextInput
                              id="シリアルNo"
                              name="シリアルNo"
                              value={シリアルNo}
                              setValue={setシリアルNo}
                              placeholder="シリアルNo"
                            />
                            <TextInput
                              id="車台番号"
                              name="車台番号"
                              value={車台番号}
                              setValue={set車台番号}
                              placeholder="車台番号"
                            />
                            <div className="w-25rem">
                              <ComboBox.SiharaiSaki
                                placeholder="整備業者"
                                isAllSelect
                                siharaiSaki={e支払先区分.整備会社}
                                isLoadEnded={整備業者IsLoadEnded}
                                setIsLoadEnded={set整備業者IsLoadEnded}
                                itemsSource={整備業者ItemSource}
                                selectedValue={整備業者コード}
                                setSelectedItem={set整備業者}
                                setSelectedValue={(v) => {
                                  set整備業者コード(v)
                                }}
                                ComboBox={整備業者ComboBox}
                                setComboBox={
                                  set整備業者ComboBox
                                }></ComboBox.SiharaiSaki>
                            </div>
                          </div>
                          <div className="search-condition-row">
                            <Button
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                beforeSearch()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>

      {/* Modalから検索 */}
      <FunctionContext.Provider
        value={() => {
          search(preSearchCondition)
        }}>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  searchConditionClear={searchConditionClear}
                  gridId={`${gridId}_1`}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  gridInitializedHandler={gridInitializedHandler}
                  isShowGridRowPickupButton={true}
                  excelFormatItem={tenkenseibihiExcelFormat}
                  pdfFormatItem={tenkenseibihiPdfFormat}
                  gridProperties={{
                    frozenColumns: 6,
                  }}>
                  <wjrGrid.FlexGridColumn
                    header=" "
                    align="center"
                    allowDragging={false}
                    width={80}
                    selectable={false}
                    isReadOnly>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkenSeibihiListGetRes>
                      ) => {
                        return (
                          <Button
                            className="btn btn-small btn-primary move-edit-page"
                            onClick={(e) => {
                              // 画面全体のスクロール位置の保存
                              gridPageHelper.savePageConditionData(
                                location.pathname
                              )
                              // ModalShow
                              e.preventDefault()
                              set車輌点検整備ID(context.item.車輌点検整備ID)
                              set車輌ID(context.item.車輌ID)
                              setIsTenkenSeibi(true)
                            }}>
                            編集
                          </Button>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    allowDragging={false}
                    binding="部所名"
                    width={180}
                    header="部所"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    allowDragging={false}
                    binding="車番"
                    width={80}
                    header="車番"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    allowDragging={false}
                    binding="登録番号"
                    width={150}
                    header="登録番号"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    allowDragging={false}
                    binding="車台番号"
                    width={150}
                    header="車台番号"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    allowDragging={false}
                    binding="シリアルNO"
                    width={130}
                    header="シリアルNO"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="車輌点検整備区分名称1"
                    width={150}
                    header="点検整備名"></wjrGrid.FlexGridColumn>

                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="点検整備予定日"
                    format={"d"}
                    width={110}
                    header="実施予定日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkenSeibihiListGetRes>
                      ) => {
                        let dt = ""
                        if (context.item.点検整備予定日)
                          dt = dayjs(context.item.点検整備予定日).format(
                            "YYYY/MM/DD"
                          )
                        return <>{dt}</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="点検整備実施日"
                    width={110}
                    header="実施日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkenSeibihiListGetRes>
                      ) => {
                        let dt = ""
                        if (context.item.点検整備実施日)
                          dt = dayjs(context.item.点検整備実施日).format(
                            "YYYY/MM/DD"
                          )
                        return <>{dt}</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="請求年月"
                    width={90}
                    header="請求年月">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TTenkenSeibihiListGetRes>
                      ) => {
                        return dateUtil.format(context.item.請求年月, "YYYY/MM")
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="支払先名"
                    width={150}
                    header="整備業者名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="整備費用合計_税込"
                    format="n"
                    width={180}
                    header="整備費用合計(税込)"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="備考"
                    width={140}
                    header="備考"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="費用備考"
                    width={140}
                    header="費用備考"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {/* 点検整備モーダル */}
        <TenkenSeibiModal
          title="点検整備費入力"
          modalType="点検整備費用"
          isShow={isTenkenSeibi}
          setIsShow={setIsTenkenSeibi}
          // ListModalIsShow={props.setIsShow}
          車輌Id={車輌ID!}
          車輌点検整備id={車輌点検整備ID!}></TenkenSeibiModal>
      </FunctionContext.Provider>
    </Container>
  )
}

export default TenkenSeibihiList
